import {Injectable} from '@angular/core';
import {ApiService} from '@abstract/api.service';

/**
 * Сервис получения НТД
 */
@Injectable()
export class TechnicalDocumentsService extends ApiService {
    baseUrl = 'standard-technical-document';

    /**
     * Получение списка методов, которые соответствуют указанной НТД
     * @param ntdId
     */
    getMethodsPath(ntdId: number): string {
        return `${this.baseUrl}/${ntdId}/methods`;
    }
}
